import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export interface IRemoveUsersFromProfileParams {
  userLuids: string[];
  adminProfileLuid?: string;
}

export class RemoveUsersFromProfileRequest extends Request<IRemoveUsersFromProfileParams, IResult> {
  constructor(params: IRemoveUsersFromProfileParams) {
    super('removeUsersFromProfile', params);
  }
}
